import { MessageCircle } from "lucide-react";
import BarGraph from "./BarChart";

interface ConvDynamicsProps {
  talkTimeRatioMentor: number;
  talkTimeRatioMentee: number;
  wordCountMentor: number;
  wordCountMentee: number;
}

const color = "green";

export const ConvDynamics = (convDynamics: ConvDynamicsProps) => {
  let {
    talkTimeRatioMentor,
    talkTimeRatioMentee,
    wordCountMentor,
    wordCountMentee,
  } = convDynamics;

  return (
    <div className="bg-white rounded-xl p-6 shadow-sm">
      <h2 className="text-xl font-semibold mb-6 flex items-center">
        <MessageCircle className={`w-5 h-5 mr-2 text-${color}-600`} />
        Conversation Dynamics
      </h2>
      <div className="grid">
        <div className="p-4 bg-gray-50 rounded-lg">
          <h3 className="font-medium text-gray-900 mb-2">
            Talk Time Distribution
          </h3>
          {talkTimeRatioMentor && talkTimeRatioMentee ? (
            <BarGraph
              data={[
                {
                  label: "Mentor",
                  number: talkTimeRatioMentor,
                  fill: "indigo",
                },
                { label: "Mentee", number: talkTimeRatioMentee, fill: "green" },
              ]}
            />
          ) : (
            <div className="flex flex-col items-center justify-center h-full">
              <p className="text-gray-600 mb-6">Loading...</p>
            </div>
          )}
        </div>
        <div className="p-4 bg-gray-50 rounded-lg">
          <h3 className="font-medium text-gray-900 mb-2">Word Count</h3>
          <div className="space-y-2">
            {wordCountMentor !== undefined && wordCountMentee !== undefined ? (
              <>
                <div>Mentor: {wordCountMentor} words</div>
                <div>Mentee: {wordCountMentee} words</div>
              </>
            ) : (
              <div className="flex flex-col items-center justify-center h-full">
                <p className="text-gray-600 mb-6">Loading...</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConvDynamics;
